module.exports = __webpack_public_path__ + "img/about_1.769870d7.jpg";